import { IPresenterProps } from './types';
import * as S from './styles';
import { IBusiness } from '../../state/api/types';
import BusinessCard from '../BusinessCard/Container';

const BusinessListPresenter = (props: IPresenterProps) => {

    return (
        <S.Container>
            {props.businesses.map((business: IBusiness, i) => {
                return (
                    <div ref={props.businessRefs[i]} key={i}>
                        <BusinessCard business={business} selected={Number(props.bussinessClickedIndex) === i}
                            refProp={props.businessRefs[i]} />
                    </div>
                )
            })
            }
        </S.Container>
    );
};

export default BusinessListPresenter;
